/**
 * Add-to-cart for the empty cart's product picks.
 *
 * Why this exists rather than the theme's own <product-form>: on the cart page
 * the empty state renders INSIDE <form id="cart">, and a form inside a form is
 * invalid HTML — the parser drops the inner tags and the Add buttons end up
 * submitting the cart update form instead. So these are plain buttons and the
 * add happens here.
 *
 * Only ever used for products with a single variant; anything with options is
 * rendered as a link to its product page, because guessing a variant on the
 * shopper's behalf is worse than one more tap.
 */
(function () {
  function sectionsFor(drawer) {
    if (!drawer || typeof drawer.getSectionsToRender !== "function") return null;
    try {
      return drawer.getSectionsToRender().map((s) => s.id);
    } catch (e) {
      return null;
    }
  }

  async function add(button) {
    const id = button.dataset.fbAdd;
    if (!id || button.getAttribute("aria-disabled") === "true") return;

    button.setAttribute("aria-disabled", "true");
    button.classList.add("is-loading");

    // Only treat this as a drawer add when the button is actually IN the open
    // drawer. On the cart page a <cart-drawer> still exists in the layout, and
    // rendering into it there would slide the drawer open over the page the
    // shopper is already looking at.
    const drawer = button.closest("cart-drawer");
    const sections = sectionsFor(drawer);
    const body = { items: [{ id: Number(id), quantity: 1 }] };
    if (sections) {
      body.sections = sections;
      body.sections_url = window.location.pathname;
    }

    try {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
      const res = await fetch(`${root}cart/add.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(body),
      }).then((r) => r.json());

      if (res.status) throw new Error(res.description || res.message);

      // Re-render the drawer in place when we can: the shopper opened it to
      // look at their cart, and reloading the page underneath them loses that.
      if (drawer && sections && typeof drawer.renderContents === "function") {
        // Second argument means "the cart was closed, so toggle it" — passing
        // true on an already-open drawer toggles it shut, which is exactly what
        // happened the first time.
        drawer.renderContents(res, !drawer.isOpen);
        if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: "empty-cart-picks" });
        }
        document.dispatchEvent(new CustomEvent("cart-drawer:refresh", { bubbles: true }));
        return;
      }
      // Cart page, or a theme that has moved on: a reload shows the item list.
      window.location.reload();
    } catch (e) {
      button.removeAttribute("aria-disabled");
      button.classList.remove("is-loading");
      // Falling back to the product page beats a dead button.
      if (button.dataset.fbUrl) window.location.href = button.dataset.fbUrl;
    }
  }

  // Delegated, because the empty state is re-rendered by the theme on every
  // cart change and a bound listener would not survive it.
  document.addEventListener("click", (e) => {
    const button = e.target.closest("[data-fb-add]");
    if (!button) return;
    e.preventDefault();
    add(button);
  });
})();
